import { routes } from "@/constants/url.ts";
import { captureError } from "@/lib/errors/capture-error";
import { checkIsNewUser, supabase } from "@/lib/supabase";
import { trackPixelReservedEvent } from "@/lib/track/pixel";
import { TrackingEvent, trackEvent } from "@/lib/track/track-event.ts";
import { Loading } from "@backpac/monica";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect_url");

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();

        if (error != null) {
          throw error;
        }

        if (!session) {
          // No session found, redirect to login
          navigate(routes.AUTH.signin);
          return;
        }

        // Check if this is a new user
        const isNewUser = checkIsNewUser(session.user);

        if (isNewUser) {
          trackEvent(TrackingEvent.SignUp, {
            name: session.user.user_metadata.name,
            email: session.user.email,
            method: "google",
          });
          trackPixelReservedEvent("Lead");
        } else {
          trackEvent(TrackingEvent.SignIn, {
            name: session.user.user_metadata.name,
            email: session.user.email,
            method: "google",
          });
        }
        if (redirectUrl != null) {
          window.location.href = redirectUrl;
        } else {
          navigate(routes.WORKSPACE_NAVIGATOR.root);
        }
      } catch (error) {
        captureError(error);
        navigate(routes.AUTH.signin);
      }
    };

    handleCallback();
  }, [navigate, redirectUrl]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Loading />
    </div>
  );
}
